export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      projects: "Projects",
      contact: "Contact",
      cta: "Get a Quote",
    },
    hero: {
      overline: "Athens · Kythera · Nationwide",
      title_a: "Engineering",
      title_b: "Excellence",
      title_c: "Built to Last",
      subtitle:
        "Premium mechanical engineering, energy systems, renovations and building solutions throughout Greece.",
      locations: "Athens · Kythera · Nationwide",
      cta_primary: "Get a Quote",
      cta_secondary: "View Projects",
    },
    stats: {
      items: [
        { v: "150+", l: "Projects Completed" },
        { v: "15+", l: "Years Combined Experience" },
        { v: "98%", l: "Client Satisfaction" },
        { v: "24/7", l: "Technical Support" },
      ],
    },
    marquee: [
      "HEAT PUMPS & HVAC",
      "UNDERFLOOR HEATING",
      "PHOTOVOLTAIC SYSTEMS",
      "KNX SMART BUILDINGS",
      "NATURAL GAS",
      "THERMAL INSULATION",
      "ALUMINIUM SYSTEMS",
      "DRYWALL & INTERIORS",
      "FULL RENOVATIONS",
    ],
    about: {
      overline: "About",
      title: "High-performance engineering for buildings that last.",
      body_1:
        "MITROLLARI Engineering Solutions delivers high-performance building and energy systems designed for efficiency, comfort and long-term value.",
      body_2:
        "From heat pumps and photovoltaics to complete renovations and mechanical installations, every project is executed with precision and attention to detail.",
      established: "Est. 2025",
      coverage: "ATHENS · KYTHERA · GREECE",
    },
    services: {
      overline: "Services",
      title: "Complete Building & Energy Solutions",
      subtitle: "Ten specialized practices delivered to a uniform standard of engineering precision.",
      items: [
        { key: "heat_pumps", title: "Heat Pumps & HVAC", desc: "High-efficiency heat pumps and HVAC systems for residential and commercial buildings." },
        { key: "floor_heating", title: "Underfloor Heating & Cooling", desc: "Hydronic underfloor heating and cooling — invisible comfort with measurable energy savings." },
        { key: "photovoltaic", title: "Photovoltaic Systems", desc: "Grid-tied and hybrid solar systems engineered for maximum yield and payback." },
        { key: "knx", title: "KNX Smart Buildings", desc: "Whole-building automation — lighting, climate, security, shading — through certified KNX integration." },
        { key: "plumbing", title: "Plumbing Installations", desc: "Premium plumbing installations and modernizations with precision-grade materials." },
        { key: "gas", title: "Natural Gas Systems", desc: "Certified natural gas networks — boilers, autonomies and complete supply systems." },
        { key: "thermal_facade", title: "Thermal Insulation", desc: "External thermal insulation (ETICS) that reduces energy bills and elevates building aesthetics." },
        { key: "aluminum", title: "Aluminium Systems", desc: "Thermal-break aluminium doors, windows and curtain wall systems — precision installed." },
        { key: "drywall", title: "Drywall & Interiors", desc: "Custom drywall partitions, ceilings and interior systems with acoustic and thermal performance." },
        { key: "renovation", title: "Full Renovations", desc: "Turnkey renovations — from demolition to finishing — managed end-to-end with refined craftsmanship." },
      ],
    },
    why: {
      overline: "Why us",
      title: "Precision. Quality. Reliability.",
      subtitle: "Four pillars that define every project we deliver.",
      items: [
        { title: "Engineering Expertise", desc: "Multi-disciplinary engineering — mechanical, electrical, energy — under a single team." },
        { title: "Energy Efficient Solutions", desc: "Every system specified for measurable reductions in consumption and lifecycle cost." },
        { title: "Premium Materials", desc: "Specified-grade materials and certified components — no shortcuts, no substitutions." },
        { title: "Turnkey Project Delivery", desc: "Single point of accountability from design to handover — and beyond, with after-care." },
      ],
    },
    projects: {
      overline: "Selected work",
      title: "Featured Projects",
      subtitle: "Selected work across luxury villas, energy upgrades and mechanical installations.",
      categories: [
        { id: "villas", title: "Luxury Villas", desc: "Architectural new-build villas with full mechanical and energy systems." },
        { id: "energy", title: "Energy Upgrades", desc: "Photovoltaics, heat pumps, ETICS and complete energy refurbishment." },
        { id: "commercial", title: "Commercial Projects", desc: "Office, retail and hospitality fit-outs delivered to commercial timelines." },
        { id: "mechanical", title: "Mechanical Installations", desc: "Plumbing, gas, HVAC and KNX systems engineered for performance." },
      ],
      filters: { all: "All", construction: "Villas", renovation: "Renovation", plumbing: "Mechanical", aluminum: "Aluminium", heating: "Energy" },
      view: "View Project",
      photos: "photos",
      in_progress: "In Progress",
      close: "Close",
    },
    testimonials: {
      overline: "Client voices",
      title: "What clients say.",
      items: [
        { quote: "Exceptional workmanship and attention to detail.", author: "A. Konstantinou", role: "Private Client — Pagrati" },
        { quote: "Professional from design through completion.", author: "M. Papadopoulou", role: "Architect — Athens" },
        { quote: "Outstanding engineering and installation quality.", author: "D. Loukas", role: "Homeowner — Kythera" },
      ],
    },
    contact: {
      overline: "Begin",
      title: "Let's Build Something Exceptional",
      subtitle: "Tell us about your project. We respond within 24 hours.",
      cta: "Request a Consultation",
      map_title: "Coverage",
      map_subtitle: "We serve Athens, Kythera and projects nationwide across Greece.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        service: "Service of interest",
        service_placeholder: "Select a service",
        subject: "Subject",
        message: "Project details",
        submit: "Request Consultation",
        submitting: "Sending...",
        success: "Message sent. We'll be in touch shortly.",
        error: "Something went wrong. Please try again.",
      },
      info: {
        phone_label: "Phone",
        email_label: "Email",
        location_label: "Coverage",
        location_value: "Athens · Kythera · Greece",
        hours_label: "Support",
        hours_value: "24/7 Technical Support",
      },
    },
    footer: {
      tagline: "Premium engineering, energy and building solutions across Greece.",
      rights: "All rights reserved.",
      built: "Athens · Kythera · Greece",
      social: "Connect",
    },
  },
  el: {
    nav: {
      home: "Αρχική",
      about: "Σχετικά",
      services: "Υπηρεσίες",
      projects: "Έργα",
      contact: "Επικοινωνία",
      cta: "Ζητήστε Προσφορά",
    },
    hero: {
      overline: "Αθήνα · Κύθηρα · Πανελλαδικά",
      title_a: "Μηχανική",
      title_b: "Υπεροχή",
      title_c: "Που Διαρκεί",
      subtitle:
        "Premium μηχανολογικές μελέτες, ενεργειακά συστήματα, ανακαινίσεις και κατασκευαστικές λύσεις σε όλη την Ελλάδα.",
      locations: "Αθήνα · Κύθηρα · Πανελλαδικά",
      cta_primary: "Ζητήστε Προσφορά",
      cta_secondary: "Δείτε Έργα",
    },
    stats: {
      items: [
        { v: "150+", l: "Ολοκληρωμένα Έργα" },
        { v: "15+", l: "Χρόνια Εμπειρίας" },
        { v: "98%", l: "Ικανοποίηση Πελατών" },
        { v: "24/7", l: "Τεχνική Υποστήριξη" },
      ],
    },
    marquee: [
      "ΑΝΤΛΙΕΣ ΘΕΡΜΟΤΗΤΑΣ",
      "ΕΝΔΟΔΑΠΕΔΙΑ ΘΕΡΜΑΝΣΗ",
      "ΦΩΤΟΒΟΛΤΑΙΚΑ",
      "KNX SMART BUILDINGS",
      "ΦΥΣΙΚΟ ΑΕΡΙΟ",
      "ΘΕΡΜΟΠΡΟΣΟΨΗ",
      "ΑΛΟΥΜΙΝΙΑ",
      "ΓΥΨΟΣΑΝΙΔΕΣ",
      "ΟΛΙΚΕΣ ΑΝΑΚΑΙΝΙΣΕΙΣ",
    ],
    about: {
      overline: "Σχετικά",
      title: "Μηχανική υψηλής απόδοσης για κτίρια που διαρκούν.",
      body_1:
        "Η MITROLLARI Engineering Solutions παραδίδει συστήματα κτιρίων και ενέργειας υψηλής απόδοσης, σχεδιασμένα για αποδοτικότητα, άνεση και μακροχρόνια αξία.",
      body_2:
        "Από αντλίες θερμότητας και φωτοβολταϊκά έως ολικές ανακαινίσεις και μηχανολογικές εγκαταστάσεις, κάθε έργο εκτελείται με ακρίβεια και προσοχή στη λεπτομέρεια.",
      established: "Ίδρυση 2025",
      coverage: "ΑΘΗΝΑ · ΚΥΘΗΡΑ · ΕΛΛΑΔΑ",
    },
    services: {
      overline: "Υπηρεσίες",
      title: "Ολοκληρωμένες Λύσεις Κτιρίων & Ενέργειας",
      subtitle: "Δέκα εξειδικευμένες υπηρεσίες με ενιαίο πρότυπο μηχανικής ακρίβειας.",
      items: [
        { key: "heat_pumps", title: "Αντλίες Θερμότητας & HVAC", desc: "Αντλίες θερμότητας και HVAC υψηλής απόδοσης για κατοικίες και επαγγελματικούς χώρους." },
        { key: "floor_heating", title: "Ενδοδαπέδια Θέρμανση & Ψύξη", desc: "Υδραυλικά συστήματα ενδοδαπέδιας θέρμανσης και ψύξης — αόρατη άνεση με μετρήσιμη εξοικονόμηση." },
        { key: "photovoltaic", title: "Φωτοβολταϊκά Συστήματα", desc: "Διασυνδεδεμένα και υβριδικά φωτοβολταϊκά για μέγιστη απόδοση και ταχεία απόσβεση." },
        { key: "knx", title: "KNX Smart Buildings", desc: "Πλήρης αυτοματισμός κτιρίου — φωτισμός, κλιματισμός, ασφάλεια, σκίαση — με πιστοποιημένο KNX." },
        { key: "plumbing", title: "Υδραυλικά", desc: "Premium υδραυλικές εγκαταστάσεις και εκσυγχρονισμοί με υλικά υψηλής ποιότητας." },
        { key: "gas", title: "Φυσικό Αέριο", desc: "Πιστοποιημένα δίκτυα φυσικού αερίου — λέβητες, αυτονομίες και ολοκληρωμένα συστήματα τροφοδοσίας." },
        { key: "thermal_facade", title: "Θερμοπρόσοψη", desc: "Εξωτερική θερμομόνωση (ETICS) που μειώνει τους λογαριασμούς ενέργειας και αναβαθμίζει την αισθητική." },
        { key: "aluminum", title: "Αλουμίνια", desc: "Κουφώματα και υαλοπετάσματα αλουμινίου με thermal break — ακριβής τοποθέτηση." },
        { key: "drywall", title: "Γυψοσανίδες & Εσωτερικά", desc: "Χωρίσματα, οροφές και custom εσωτερικές κατασκευές γυψοσανίδας με ηχητική και θερμική απόδοση." },
        { key: "renovation", title: "Ολικές Ανακαινίσεις", desc: "Ανακαινίσεις «με το κλειδί στο χέρι» — από καθαίρεση έως φινίρισμα." },
      ],
    },
    why: {
      overline: "Γιατί εμάς",
      title: "Ακρίβεια. Ποιότητα. Αξιοπιστία.",
      subtitle: "Τέσσερις πυλώνες που ορίζουν κάθε έργο που παραδίδουμε.",
      items: [
        { title: "Τεχνογνωσία Μηχανικής", desc: "Διεπιστημονική μηχανική — μηχανολογική, ηλεκτρολογική, ενεργειακή — υπό μία ομάδα." },
        { title: "Ενεργειακά Αποδοτικές Λύσεις", desc: "Κάθε σύστημα σχεδιασμένο για μετρήσιμη μείωση κατανάλωσης και κόστους ζωής." },
        { title: "Premium Υλικά", desc: "Πιστοποιημένα υλικά και components — χωρίς συμβιβασμούς, χωρίς υποκαταστάσεις." },
        { title: "Παράδοση Με Το Κλειδί", desc: "Μία ευθύνη από τη μελέτη έως την παράδοση — και πέρα, με after-care." },
      ],
    },
    projects: {
      overline: "Επιλεγμένα έργα",
      title: "Επιλεγμένα Έργα",
      subtitle: "Επιλεγμένα έργα σε luxury βίλες, ενεργειακές αναβαθμίσεις και μηχανολογικές εγκαταστάσεις.",
      categories: [
        { id: "villas", title: "Luxury Βίλες", desc: "Αρχιτεκτονικές νέες κατασκευές με πλήρη μηχανολογικά και ενεργειακά συστήματα." },
        { id: "energy", title: "Ενεργειακές Αναβαθμίσεις", desc: "Φωτοβολταϊκά, αντλίες θερμότητας, ETICS και πλήρης ενεργειακή ανακαίνιση." },
        { id: "commercial", title: "Επαγγελματικά Έργα", desc: "Γραφεία, καταστήματα και χώροι φιλοξενίας σε επαγγελματικά χρονοδιαγράμματα." },
        { id: "mechanical", title: "Μηχανολογικές Εγκαταστάσεις", desc: "Υδραυλικά, αέριο, HVAC και συστήματα KNX σχεδιασμένα για απόδοση." },
      ],
      filters: { all: "Όλα", construction: "Βίλες", renovation: "Ανακαίνιση", plumbing: "Μηχανολογικά", aluminum: "Αλουμίνια", heating: "Ενέργεια" },
      view: "Δείτε το Έργο",
      photos: "φωτογραφίες",
      in_progress: "Σε εξέλιξη",
      close: "Κλείσιμο",
    },
    testimonials: {
      overline: "Λόγια πελατών",
      title: "Τι λένε οι πελάτες.",
      items: [
        { quote: "Εξαιρετική εργασία και προσοχή στη λεπτομέρεια.", author: "A. Κωνσταντίνου", role: "Ιδιώτης Πελάτης — Παγκράτι" },
        { quote: "Επαγγελματίες από τη μελέτη έως την παράδοση.", author: "M. Παπαδοπούλου", role: "Αρχιτέκτων — Αθήνα" },
        { quote: "Κορυφαία μηχανική και ποιότητα εγκατάστασης.", author: "Δ. Λούκας", role: "Ιδιοκτήτης — Κύθηρα" },
      ],
    },
    contact: {
      overline: "Ξεκίνημα",
      title: "Ας Κατασκευάσουμε Κάτι Ξεχωριστό",
      subtitle: "Πείτε μας για το έργο σας. Απαντάμε εντός 24 ωρών.",
      cta: "Ζητήστε Συμβουλευτική",
      map_title: "Κάλυψη",
      map_subtitle: "Εξυπηρετούμε Αθήνα, Κύθηρα και έργα πανελλαδικά σε όλη την Ελλάδα.",
      form: {
        name: "Ονοματεπώνυμο",
        email: "Email",
        phone: "Τηλέφωνο",
        service: "Υπηρεσία ενδιαφέροντος",
        service_placeholder: "Επιλέξτε υπηρεσία",
        subject: "Θέμα",
        message: "Λεπτομέρειες έργου",
        submit: "Ζητήστε Συμβουλευτική",
        submitting: "Αποστολή...",
        success: "Το μήνυμα στάλθηκε. Θα επικοινωνήσουμε σύντομα.",
        error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
      },
      info: {
        phone_label: "Τηλέφωνο",
        email_label: "Email",
        location_label: "Κάλυψη",
        location_value: "Αθήνα · Κύθηρα · Ελλάδα",
        hours_label: "Υποστήριξη",
        hours_value: "24/7 Τεχνική Υποστήριξη",
      },
    },
    footer: {
      tagline: "Premium μηχανική, ενεργειακές και κατασκευαστικές λύσεις σε όλη την Ελλάδα.",
      rights: "Όλα τα δικαιώματα διατηρούνται.",
      built: "Αθήνα · Κύθηρα · Ελλάδα",
      social: "Δίκτυα",
    },
  },
};
